module.exports = __webpack_public_path__ + "98ccc2b7f18991a5126a91ac56fbb1fc.woff2";